.bd{overflow:hidden;}